// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  id: __t.string(),
  orgId: __t.string(),
  projectId: __t.string(),
  folderId: __t.string(),
  name: __t.string(),
  mime: __t.string(),
  ext: __t.string(),
  sizeBytes: __t.f64(),
  spaceId: __t.string(),
};
